"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendDeepLinkEvent = exports.sendNavigationEvent = exports.sendAthaEvent = exports.eventsClientHasBeenInitialized = exports.eventsClientExists = exports.sendAppPageViewEvent = exports.sendPageViewEvent = exports.sendEvent = exports.sendSessionStartEvent = exports.initialiseEventsClient = exports.PAGE_NAME = exports.COMPONENT_NAME = exports.sendDownloadPromptEvent = exports.sendPollViewEvent = exports.sendSignupPromptViewEvent = exports.sendLoginPromptViewEvent = exports.moduleContentClickEvent = exports.featuredCarouselSlideViewEvent = exports.featuredCarouselSlideClickEvent = exports.readingListClickEvent = exports.tagClickEvent = exports.sectionViewEvent = exports.sendLoginLandingEvent = exports.sendOnboardingGenreEvent = exports.sendOnBoardingStartTrackingEvent = exports.sendOnBoardingCompleteTrackingEvent = exports.sendEmailVerificationTrackingEvent = exports.sendReconciliationEvent = exports.sendBrowseTrackingEvent = exports.getNotificationEventTypeName = exports.sendNotificationClickEvent = exports.sendInviteFriendsEvent = exports.sendSearchTrackingEvent = exports.readingListShareEvent = exports.sendLibraryClickEvent = exports.sendRemoveFromArchiveEvent = exports.sendAddToArchiveEvent = exports.sendRemoveFromLibraryEvent = exports.sendAddToLibraryEvent = exports.clickStoryEventPerPage = exports.clickStoryEvent = exports.sendStoryViewEvent = exports.sendSignupLandingEvent = exports.sendSignupAppEvent = void 0;
var TrackEverything_1 = require("./TrackEverything/TrackEverything");
var SignupEvents_1 = require("./SignupEvents");
Object.defineProperty(exports, "sendSignupAppEvent", { enumerable: true, get: function () { return SignupEvents_1.sendSignupAppEvent; } });
Object.defineProperty(exports, "sendSignupLandingEvent", { enumerable: true, get: function () { return SignupEvents_1.sendSignupLandingEvent; } });
var StoryEvents_1 = require("./StoryEvents");
Object.defineProperty(exports, "sendStoryViewEvent", { enumerable: true, get: function () { return StoryEvents_1.sendStoryViewEvent; } });
Object.defineProperty(exports, "clickStoryEvent", { enumerable: true, get: function () { return StoryEvents_1.clickStoryEvent; } });
Object.defineProperty(exports, "clickStoryEventPerPage", { enumerable: true, get: function () { return StoryEvents_1.clickStoryEventPerPage; } });
var LibraryEvents_1 = require("./LibraryEvents");
Object.defineProperty(exports, "sendAddToLibraryEvent", { enumerable: true, get: function () { return LibraryEvents_1.sendAddToLibraryEvent; } });
Object.defineProperty(exports, "sendRemoveFromLibraryEvent", { enumerable: true, get: function () { return LibraryEvents_1.sendRemoveFromLibraryEvent; } });
Object.defineProperty(exports, "sendAddToArchiveEvent", { enumerable: true, get: function () { return LibraryEvents_1.sendAddToArchiveEvent; } });
Object.defineProperty(exports, "sendRemoveFromArchiveEvent", { enumerable: true, get: function () { return LibraryEvents_1.sendRemoveFromArchiveEvent; } });
Object.defineProperty(exports, "sendLibraryClickEvent", { enumerable: true, get: function () { return LibraryEvents_1.sendLibraryClickEvent; } });
Object.defineProperty(exports, "readingListShareEvent", { enumerable: true, get: function () { return LibraryEvents_1.readingListShareEvent; } });
var SearchEvents_1 = require("./SearchEvents");
Object.defineProperty(exports, "sendSearchTrackingEvent", { enumerable: true, get: function () { return SearchEvents_1.sendSearchTrackingEvent; } });
var InvitationEvents_1 = require("./InvitationEvents");
Object.defineProperty(exports, "sendInviteFriendsEvent", { enumerable: true, get: function () { return InvitationEvents_1.sendInviteFriendsEvent; } });
var NotificationEvents_1 = require("./NotificationEvents");
Object.defineProperty(exports, "sendNotificationClickEvent", { enumerable: true, get: function () { return NotificationEvents_1.sendNotificationClickEvent; } });
Object.defineProperty(exports, "getNotificationEventTypeName", { enumerable: true, get: function () { return NotificationEvents_1.getNotificationEventTypeName; } });
var BrowseEvents_1 = require("./BrowseEvents");
Object.defineProperty(exports, "sendBrowseTrackingEvent", { enumerable: true, get: function () { return BrowseEvents_1.sendBrowseTrackingEvent; } });
var ReconciliationEvents_1 = require("./ReconciliationEvents");
Object.defineProperty(exports, "sendReconciliationEvent", { enumerable: true, get: function () { return ReconciliationEvents_1.sendReconciliationEvent; } });
var onBoardingEvents_1 = require("./onBoardingEvents");
Object.defineProperty(exports, "sendEmailVerificationTrackingEvent", { enumerable: true, get: function () { return onBoardingEvents_1.sendEmailVerificationTrackingEvent; } });
Object.defineProperty(exports, "sendOnBoardingCompleteTrackingEvent", { enumerable: true, get: function () { return onBoardingEvents_1.sendOnBoardingCompleteTrackingEvent; } });
Object.defineProperty(exports, "sendOnBoardingStartTrackingEvent", { enumerable: true, get: function () { return onBoardingEvents_1.sendOnBoardingStartTrackingEvent; } });
Object.defineProperty(exports, "sendOnboardingGenreEvent", { enumerable: true, get: function () { return onBoardingEvents_1.sendOnboardingGenreEvent; } });
var LoginEvents_1 = require("./LoginEvents");
Object.defineProperty(exports, "sendLoginLandingEvent", { enumerable: true, get: function () { return LoginEvents_1.sendLoginLandingEvent; } });
var HomeEvents_1 = require("./HomeEvents");
Object.defineProperty(exports, "sectionViewEvent", { enumerable: true, get: function () { return HomeEvents_1.sectionViewEvent; } });
Object.defineProperty(exports, "tagClickEvent", { enumerable: true, get: function () { return HomeEvents_1.tagClickEvent; } });
Object.defineProperty(exports, "readingListClickEvent", { enumerable: true, get: function () { return HomeEvents_1.readingListClickEvent; } });
Object.defineProperty(exports, "featuredCarouselSlideClickEvent", { enumerable: true, get: function () { return HomeEvents_1.featuredCarouselSlideClickEvent; } });
Object.defineProperty(exports, "featuredCarouselSlideViewEvent", { enumerable: true, get: function () { return HomeEvents_1.featuredCarouselSlideViewEvent; } });
Object.defineProperty(exports, "moduleContentClickEvent", { enumerable: true, get: function () { return HomeEvents_1.moduleContentClickEvent; } });
var view_1 = require("./events/authentication/view");
Object.defineProperty(exports, "sendLoginPromptViewEvent", { enumerable: true, get: function () { return view_1.sendLoginPromptViewEvent; } });
Object.defineProperty(exports, "sendSignupPromptViewEvent", { enumerable: true, get: function () { return view_1.sendSignupPromptViewEvent; } });
var PollEvents_1 = require("./PollEvents");
Object.defineProperty(exports, "sendPollViewEvent", { enumerable: true, get: function () { return PollEvents_1.sendPollViewEvent; } });
var MobileDownloadPrompt_1 = require("./events/persistent-banner/MobileDownloadPrompt");
Object.defineProperty(exports, "sendDownloadPromptEvent", { enumerable: true, get: function () { return MobileDownloadPrompt_1.sendDownloadPromptEvent; } });
var constants_1 = require("./constants");
Object.defineProperty(exports, "COMPONENT_NAME", { enumerable: true, get: function () { return constants_1.COMPONENT_NAME; } });
Object.defineProperty(exports, "PAGE_NAME", { enumerable: true, get: function () { return constants_1.PAGE_NAME; } });
var initialiseEventsClient = function (_a) {
    var deviceType = _a.deviceType, _b = _a.userId, userId = _b === void 0 ? null : _b;
    var TrackEverything = (0, TrackEverything_1.TrackEverythingFactory)(window);
    window.te = new TrackEverything();
    window.te.push("create", deviceType, null, userId);
};
exports.initialiseEventsClient = initialiseEventsClient;
var sendSessionStartEvent = function (_a) {
    var _b;
    var details = _a.details;
    if (!(0, exports.eventsClientExists)()) {
        console.error("HTTP Event Client cannot be found");
        return;
    }
    if (((_b = window === null || window === void 0 ? void 0 : window.te) === null || _b === void 0 ? void 0 : _b.sessionInitialised) === undefined) {
        window.te.push("event", "app", "session", null, "start", details);
        window.te.sessionInitialised = true;
    }
};
exports.sendSessionStartEvent = sendSessionStartEvent;
var sendEvent = function (page, section, element, action, eventDetails) {
    if (!(0, exports.eventsClientExists)()) {
        console.error("HTTP Event Client cannot be found");
        return;
    }
    window.te.push("event", page, section, element, action, eventDetails);
};
exports.sendEvent = sendEvent;
/**
 * Sends an event that a specific page was viewed
 * Event name: "app:page::view"
 * @param page name of the page that was viewed
 */
var sendPageViewEvent = function (page, details) {
    (0, exports.sendEvent)("app", "page", null, "view", __assign({ page: page }, details));
};
exports.sendPageViewEvent = sendPageViewEvent;
/**
 * Sends an event that a specific page was viewed
 * Event name: "::::app_page_view_v1"
 * @param page name of the page that was viewed
 * @param details additional details
 */
var sendAppPageViewEvent = function (page, details) {
    var _a;
    (0, exports.sendEvent)(null, null, null, "app_page_view_v1", {
        page: (_a = {},
            _a[page] = details,
            _a),
    });
};
exports.sendAppPageViewEvent = sendAppPageViewEvent;
var eventsClientExists = function () {
    return window === null || window === void 0 ? void 0 : window.te;
};
exports.eventsClientExists = eventsClientExists;
var eventsClientHasBeenInitialized = function () {
    var _a;
    return !!((_a = window === null || window === void 0 ? void 0 : window.te) === null || _a === void 0 ? void 0 : _a.baseUrl);
};
exports.eventsClientHasBeenInitialized = eventsClientHasBeenInitialized;
var sendAthaEvent = function (eventType, message) {
    (0, exports.sendEvent)("ad", "internal", null, eventType, message);
};
exports.sendAthaEvent = sendAthaEvent;
var sendNavigationEvent = function (eventDetails) {
    (0, exports.sendEvent)("wattpad", null, null, "navigate", eventDetails);
};
exports.sendNavigationEvent = sendNavigationEvent;
var sendDeepLinkEvent = function (entity, eventDetails) {
    if (!(0, exports.eventsClientExists)()) {
        console.error("HTTP Event Client cannot be found");
        return;
    }
    window.te.push("event", "wattpad", entity, null, "deeplink", eventDetails);
};
exports.sendDeepLinkEvent = sendDeepLinkEvent;
